import React from 'react';
import { useSelector } from 'react-redux';
import { deviceTypes } from '../../../../enums/deviceTypes';
import classes from '../ContentPromotionPopup.module.css';

const PdfContent = ({ url, title }) => {

    const { texts } = useSelector(state => state.translate);
    const { deviceType } = useSelector(state => state.responsive);

    return (
        <>
            {deviceType === deviceTypes.mobile ?
                <div className={classes.PdfOpen}>
                    <a
                        className={classes.PdfOpenLink}
                        href={url}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        {texts.openPdf}
                    </a>
                </div>
                :
                <iframe
                    className={classes.Renderer}
                    src={`${url}#toolbar=0&navpanes=0&view=FitH`}
                    title={title}
                />
            }
        </>
    )
};

export default PdfContent;